import React, { useEffect, useLayoutEffect, useState, useRef } from "react";
import {
  Box,
  Collapse,
  Grid,
  IconButton,
  InputAdornment,
  Menu,
  TextField,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { connect } from "react-redux";
import {
  RESET_ACTIVITY_STATE,
  START_GET_ACTIVITY_LOG,
  START_GET_FIELD_STAFF_LIST,
} from "../../Actions/ActivityAction";
import moment from "moment";
import { ReactComponent as SearchIcon } from "../../Assets/Icons/SearchIcon.svg";
import _ from "underscore";
import { getClearObject } from "../../utils/generalUtils";
import { useIntersection } from "../../Hooks/customHooks";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import InsertInvitationIcon from "@mui/icons-material/InsertInvitation";
import ClearIcon from "@mui/icons-material/Clear";
import "../../Sass/Common.scss";
import ActivityLogTable from "./ActivityLogTable";
import PrimaryIcon from "../../Components/Common/PrimaryIcon";
import { ReactComponent as ModalCloseIcon } from "../../Assets/Icons/PharmsmartIcon/ModalCloseIcon.svg";
import FilterListIcon from "@mui/icons-material/FilterList";
import KeyboardArrowDownOutlinedIcon from "@mui/icons-material/KeyboardArrowDownOutlined";
import KeyboardArrowUpOutlinedIcon from "@mui/icons-material/KeyboardArrowUpOutlined";
import StaffAutoComplete from "../../Components/Patients/StaffAutoComplete";
// const StaffAutoComplete = React.lazy(() =>
//   import("Components/Patients/StaffAutoComplete")
// );

const useStyle = makeStyles((theme) => ({
  rsActivityHeader: {
    backgroundColor: " #333",
    display: "flex !important",
    justifyContent: "end",
    alignItems: "center",
    padding: "6px 6px",

    [theme.breakpoints.down(1100)]: {
      display: "grid",
      gridTemplateColumns: "repeat(2,0fr)",
      "&>div": {
        margin: "5px",
      },
    },
    [theme.breakpoints.down(500)]: {
      gridTemplateColumns: "repeat(1,0fr)",
      justifyContent: "start",
      paddingTop: "7px !important",
      padding: "0px 6px",
    },
    // marginBottom: "20px",
    // display: "flex",
    // justifyContent: "end",
    "&>button": {
      marginLeft: "0",
      fontSize: "14px",
      height: "37px !important",
    },
    "&>div": {
      marginTop: "0px",
      width: "200px",
      marginRight: "5px",
      marginLeft: "5px",
      height: "37px !important",
      "&>div": {
        marginTop: "0px",
        height: "37px !important",
        "&>div": {
          height: "37px !important",
        },
      },
    },
    "&>div:nth-child(3)": {
      background: "transparent",
      boxShadow: "none",
    },
  },
  autoCompleteBox: {
    background: theme.palette.white.main,
    boxShadow: "0px 0px 10px rgb(90 104 114 / 10%)",
    borderRadius: "4px",
    marginRight: "20px !important",
    minWidth: "280px !important",
    "& .MuiOutlinedInput-notchedOutline": {
      border: 0,
    },
    [theme.breakpoints.down(1100)]: {
      minWidth: "200px !important",
    },
  },
  removeBorderColor: {
    "&>div": {
      "&>fieldset": {
        borderColor: "transparent !important",
      },
      "&>div": {
        "&>fieldset": {
          borderColor: "transparent !important",
        },
      },
    },
  },

  rsCursor: {
    cursor: "pointer",
  },
  rsListAlignment: {
    display: "flex",
    marginBottom: "11px",
    marginTop: "10px",
    justifyContent: "space-between",
    "&>div": {
      display: "flex",
    },
  },
  rsActiveBtn: {
    display: "flex",
    background: theme.palette.primary.main,
    height: "10px",
    width: "10px",
    borderRadius: "5px",
    position: "relative",
    marginTop: "8px",
    marginLeft: "5px",
    justifyContent: "flex-start !important",
  },
  rsiconBtn: {
    display: "flex",
    position: "relative",
  },
  rsIconBtnWarning: {
    display: "flex",
    position: "relative",
    bottom: "-5px",
  },
  rsActiveIconBtn: {
    display: "flex",
    background: theme.palette.primary.main,
    height: "8px",
    width: "8px",
    borderRadius: "5px",
    marginTop: "8px",
    marginLeft: "5px",
    position: "absolute",
    left: "12px",
    top: "3px",
  },
  rsActiveIconWarBtn: {
    display: "flex",
    background: theme.palette.primary.main,
    height: "8px",
    width: "8px",
    borderRadius: "5px",
    marginTop: "8px",
    marginLeft: "5px",
    position: "absolute",
    left: "18px",
    top: "3px",
  },
  rsWaringFilterlistview: {
    "&>li": {
      display: "block",
      marginBottom: "10px",
      // marginTop: "10px",
      "&>svg": {
        top: "5px",
        position: "relative",
      },
      "&>div": {
        margin: "0px !important",
      },
    },
  },
  rsiconBtnForFilter: {
    width: "auto !important",
    marginRight: "5px",
    "&>div": {
      background: "#7BC044 !important",
      display: "flex !important",
      justifyContent: "center",
      alignItems: "center",
      borderRadius: "5px",
      // cursor: "pointer",
      width: "auto !important",
      height: "40px !important",
      padding: "6px",
      "&>button": {
        padding: "4px",
        cursor: "pointer",
        color: "white",
        fontSize: "18px",
        "&:hover": {
          background: "transparent",
        },
        "&>svg": {
          fill: "white",
          "&>rect": {
            fill: "white",
          },
          // fontSize: "35px",
        },
      },
    },
    "&>hr": {
      color: "#5A6872",
      background: "#5A6872",
      paddingTop: "5px",
      paddingBottom: "5px",
    },
  },
}));

const ActivityLogMain = (props) => {
  const classes = useStyle();
  const {
    activityList,
    getActivityAction,
    getSearchStaffListAction,
    reSetActivityState,
  } = props;
  const [setTarget, entry] = useIntersection({ threshold: 0.1 });
  const [searchValue, setSearchValue] = useState("");
  const [selectedStaffData, setSelectedStaffData] = useState([]);
  const staffListFlag = true;
  const defaultColumnOrderBy = "asc";
  const [columnSortingOrder, setColumnSortingOrder] = useState({
    orderBy: "",
    sortBy: "",
  });
  const [filterFromDate, setFilterFromDate] = useState(null);
  const [filterFromDateError, setFilterFromDateError] = useState("");
  const [filterToDate, setFilterToDate] = useState(null);
  const [filterToDateError, setFilterToDateError] = useState("");
  const [openToDate, setOpenToDate] = useState(false);
  const [openFromDate, setOpenFromDate] = useState(false);
  const [daysFilter, setDaysFilter] = useState("7_days");
  const [callDate, setCallDate] = useState(false);
  const [toDateOpen, setToDateOpen] = useState(false);
  const [fromDateOpen, setFromDateOpen] = useState(false);
  const [staffOpen, setStaffOpen] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [filterCount, setFilterCount] = useState(0);
  const [firstFrom, setFirstFrom] = useState(true);
  const [firstTo, setFirstTo] = useState(true);
  const [firstSurgery, setFirstSurgery] = useState(true);
  const open = Boolean(anchorEl);
  const handleClickFilter = (event) => {
    setAnchorEl(event?.currentTarget);
  };
  const handleCloseFilter = () => {
    setAnchorEl(null);
  };
  /** get api call */
  useLayoutEffect(() => {
    getSearchStaffListAction({ offset: 0 });
    // getActivityAction({ offset: 0, limit: 25 }, false);
  }, []);

  /** Get api call main function */
  const searchActivityLogAction = (
    params = {},
    tempDaysFilter = "",
    loadmore = true
  ) => {
    let payload = {
      offset: 0,
      q: searchValue,
      limit: 25,
      order_by: columnSortingOrder.orderBy,
      sort_by: columnSortingOrder.sortBy.toUpperCase(),
      staff_id: Object.keys(selectedStaffData),
    };

    if (filterFromDate !== null && filterToDate !== null) {
      payload.date = {
        from:
          filterFromDate != null
            ? moment(filterFromDate).format("YYYY-MM-DD")
            : null,
        to:
          filterToDate != null
            ? moment(filterToDate).format("YYYY-MM-DD")
            : null,
      };
    }
    if (filterFromDate !== null && filterToDate == null) {
      payload.date = {
        from:
          filterFromDate != null
            ? moment(filterFromDate).format("YYYY-MM-DD")
            : null,
      };
    }

    if (
      filterFromDate == null &&
      filterToDate == null &&
      tempDaysFilter !== ""
    ) {
      var today = new Date();
      let tempDate = new Date(today);
      let fromDate = null;
      if (tempDaysFilter === "7_days") {
        fromDate = tempDate.setDate(today.getDate() - 7);
      }
      if (tempDaysFilter === "month") {
        fromDate = tempDate.setMonth(today.getMonth() - 1);
      }
      if (tempDaysFilter === "6_months") {
        fromDate = tempDate.setMonth(today.getMonth() - 6);
      }
      if (tempDaysFilter === "year") {
        fromDate = tempDate.setFullYear(today.getFullYear() - 1);
      }
      if (tempDaysFilter === "all") {
        fromDate = tempDate.setDate(today.getDate() - 7);
      }
      if (tempDaysFilter === "all") {
        payload.all_record = true;
      } else {
        payload.date = {
          from: moment(fromDate).format("YYYY-MM-DD"),
          to: moment(new Date()).format("YYYY-MM-DD"),
        };
      }
    }

    payload = {
      ...payload,
      ...params,
    };
    getActivityAction(getClearObject(payload), loadmore);
  };

  /** Search activity log debounce Function */
  const searchActivityLogDebounce = useRef(
    _.debounce((searchString, otherStateValues = {}) => {
      searchActivityLogAction({
        ...(searchString && {
          q: searchString,
        }),
        ...otherStateValues,
      });
    }, 500)
  );

  /** for lazy loading */
  useEffect(() => {
    if (entry.isIntersecting) {
      if (
        activityList?.data?.list?.length !== activityList?.data?.filterd_record
      ) {
        searchActivityLogAction(
          {
            offset: activityList?.data?.list?.length,
            limit: 25,
            order_by: columnSortingOrder.orderBy,
            sort_by: columnSortingOrder.sortBy.toUpperCase(),
          }
          // daysFilter,
          // true
        );
      }
    }
  }, [entry]);

  /** Search activity log action */
  const handleActivityLogSearchAction = (newValue) => {
    setSearchValue(newValue);
    searchActivityLogDebounce.current(newValue, {});
  };

  /** handle Surgery Change */
  const handleStaffFilterAction = (value) => {
    if (Object.keys(value).length == 0) {
      setFilterCount((prevCount) => prevCount - 1);
      setFirstSurgery(true);
    }
    if (firstSurgery) {
      if (Object.keys(value).length == 1) {
        setFilterCount((prevCount) => prevCount + 1);
      }
      setFirstSurgery(false);
    }

    setSelectedStaffData(value);
    searchActivityLogAction({
      staff_id: Object.keys(value),
    });
  };

  /** Detect column order changes */
  useEffect(() => {
    if (
      columnSortingOrder?.orderBy !== "" ||
      columnSortingOrder?.sortBy !== ""
    ) {
      searchActivityLogAction();
    }
  }, [columnSortingOrder]);

  /** handle date filter  */
  const handleDateFilterAction = (date, type) => {
    let tempDate = new Date(date);
    if (type === "from_date") {
      if (date == null) {
        setFilterCount((prevCount) => prevCount - 1);
        setFirstFrom(true);
      }
      if (firstFrom) {
        if (tempDate !== "Invalid Date") {
          setFilterCount((prevCount) => prevCount + 1);
        }
        setFirstFrom(false);
      }
    } else {
      if (date == null) {
        setFilterCount((prevCount) => prevCount - 1);
        setFirstTo(true);
      }
      if (firstTo) {
        if (tempDate !== "Invalid Date") {
          setFilterCount((prevCount) => prevCount + 1);
        }
        setFirstTo(false);
      }
    }

    if (type === "from_date" && tempDate !== "Invalid Date") {
      setFilterFromDate(date ? tempDate : null);
      if ((tempDate <= filterToDate || filterToDate == null) && date !== null) {
        setFilterToDateError("");
        setFilterFromDateError("");
      } else {
        /** update error message */
        if (filterToDate !== null || date == null)
          setFilterFromDateError("From date should be less than to date");
      }
    } else {
      if (date !== null && type === "from_date") {
        setFilterFromDateError("Please enter valid date");
      }
    }

    if (type === "to_date" && tempDate !== "Invalid Date") {
      setFilterToDate(date ? tempDate : null);
      if (tempDate >= filterFromDate && filterFromDate != null) {
        setFilterFromDateError("");
        setFilterToDateError("");
      } else {
        /** update error message*/
        if (date !== null) {
          setFilterToDateError("To date should be greater than from date");
        }
      }
    } else {
      if (date !== null && type === "to_date") {
        setFilterToDateError("Please enter valid date");
      }
    }
  };

  /** handle filter from  date changes  */
  useEffect(() => {
    if (filterFromDate !== "Invalid Date" && callDate) {
      if (filterFromDate > new Date()) {
        setFilterFromDateError("From date should be less than to future date");
      }
      if (filterFromDate && filterFromDate <= new Date()) {
        setFilterFromDateError("");
        /** filter activity log */

        searchActivityLogAction({
          date: {
            from:
              filterFromDate !== null
                ? moment(filterFromDate).format("YYYY-MM-DD")
                : null,
          },
        });
      }

      if (
        filterFromDate &&
        filterFromDate <= new Date() &&
        filterToDate !== null
      ) {
        setFilterFromDateError("");

        /** filter activity log */
        searchActivityLogAction({
          date: {
            from:
              filterFromDate !== null
                ? moment(filterFromDate).format("YYYY-MM-DD")
                : null,
            to: moment(filterToDate).format("YYYY-MM-DD"),
          },
        });
      }
      if (filterFromDate == null) {
        setFilterFromDateError("");
        setFilterToDateError("");
        searchActivityLogAction({});
      }
    }
  }, [filterFromDate]);

  /** handle filter to  date changes  */
  useEffect(() => {
    if (filterToDate !== "Invalid Date" && callDate) {
      if (filterToDate > new Date()) {
        setFilterToDateError("To date should be less than to future date");
      }
      if (
        filterToDate &&
        filterToDate <= new Date() &&
        filterToDate >= filterFromDate &&
        filterFromDate !== null
      ) {
        setFilterToDateError("");
        /** filter activity log */
        searchActivityLogAction({
          date: {
            from:
              filterFromDate !== null
                ? moment(filterFromDate).format("YYYY-MM-DD")
                : null,
            to: moment(filterToDate).format("YYYY-MM-DD"),
          },
        });
      }
      if (filterToDate == null && filterFromDate != null) {
        if (filterToDate == null) {
          setFilterFromDateError("");
          setFilterToDateError("");
          searchActivityLogAction({});
        } else {
          /** filter activity log */
          searchActivityLogAction({
            date: {
              from:
                filterFromDate !== null
                  ? moment(filterFromDate).format("YYYY-MM-DD")
                  : null,
            },
          });
        }
      }
      // if (filterToDate == null) {
      //   setFilterFromDateError("");
      //   setFilterToDateError("");
      //   searchActivityLogAction({});
      // }
    }
  }, [filterToDate]);

  useEffect(() => {
    searchActivityLogAction({});
    setCallDate(true);
  }, []);

  const handleToDateopen = () => {
    setToDateOpen(!toDateOpen);
  };
  const handleFromDateopen = () => {
    setFromDateOpen(!fromDateOpen);
  };
  const handleStaffopen = () => {
    setStaffOpen(!staffOpen);
  };
  const handleClickFilterClear = () => {
    setSelectedStaffData([]);
    // searchActivityLogAction({
    //   // staff_id: Object.keys(value),
    // });
    setFilterFromDate(null);
    setFilterToDate(null);
    setFirstTo(true);
    setFirstFrom(true);
    setFilterCount(0);
    reSetActivityState();
    // getActivityAction({ offset: 0, limit: 25 }, false);
  };

  return (
    <Grid>
      <Grid className={classes.rsActivityHeader}>
        <TextField
          withPadding={true}
          medium
          secondary
          placeholder="Search..."
          value={searchValue}
          onChange={(e) => {
            handleActivityLogSearchAction(e?.target?.value);
          }}
          InputProps={{
            endAdornment: (
              <>
                <InputAdornment position="end">
                  <PrimaryIcon width="20px" icon={SearchIcon} />
                </InputAdornment>
              </>
            ),
          }}
        />
        <Box className={classes.rsiconBtnForFilter}>
          <Box>
            <IconButton onClick={handleClickFilter}>
              <FilterListIcon />
              {filterCount > 0 && filterCount}
            </IconButton>
            {filterCount > 0 && (
              <IconButton onClick={handleClickFilterClear}>
                <ModalCloseIcon />
              </IconButton>
            )}
          </Box>
          <Menu
            id="long-menu"
            MenuListProps={{
              "aria-labelledby": "long-button",
            }}
            anchorEl={anchorEl}
            open={open}
            onClose={handleCloseFilter}
            PaperProps={{
              style: {
                padding: "0px 10px 10px 10px ",
                // maxHeight: ITEM_HEIGHT * 4.5,
                width: "32ch",
                marginTop: "10px",
              },
            }}
          >
            <li
              className={classes.rsCursor}
              onClick={() => handleFromDateopen()}
            >
              <Box className={classes.rsListAlignment}>
                <Box>
                  From Date
                  {filterFromDate && (
                    <Box className={classes.rsActiveBtn}></Box>
                  )}
                </Box>
                <PrimaryIcon
                  width="20px"
                  height="20px"
                  icon={
                    fromDateOpen
                      ? KeyboardArrowUpOutlinedIcon
                      : KeyboardArrowDownOutlinedIcon
                  }
                />
              </Box>
            </li>
            <Collapse in={fromDateOpen}>
              <ul className={classes.rsWaringFilterlistview}>
                <li>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      // className={classes.removeBorderColor}
                      open={openFromDate}
                      onClose={() => setOpenFromDate(false)}
                      disableFuture
                      // label="From date"
                      inputFormat="DD-MM-YYYY"
                      value={filterFromDate}
                      onChange={(newDate) => {
                        handleDateFilterAction(newDate, "from_date");
                      }}
                      renderInput={(params) => (
                        <TextField
                          fullWidth
                          InputLabelProps={{
                            shrink: true,
                          }}
                          size="small"
                          name="order_date"
                          {...params}
                          error={filterFromDateError !== ""}
                          helperText={filterFromDateError}
                          InputProps={{
                            endAdornment: (
                              <>
                                {filterFromDate !== null && (
                                  <InputAdornment
                                    position="end"
                                    onClick={() =>
                                      handleDateFilterAction(null, "from_date")
                                    }
                                    className="cursor-pointer"
                                  >
                                    <PrimaryIcon
                                      width="20px"
                                      icon={ClearIcon}
                                    />
                                  </InputAdornment>
                                )}
                                <InputAdornment
                                  position="end"
                                  onClick={() => setOpenFromDate(true)}
                                  className="cursor-pointer"
                                >
                                  <PrimaryIcon
                                    width="20px"
                                    icon={InsertInvitationIcon}
                                  />
                                </InputAdornment>
                              </>
                            ),
                          }}
                        />
                      )}
                    />
                  </LocalizationProvider>
                </li>
              </ul>
            </Collapse>
            <hr />
            <li className={classes.rsCursor} onClick={() => handleToDateopen()}>
              <Box className={classes.rsListAlignment}>
                <Box>
                  To Date
                  {filterToDate && <Box className={classes.rsActiveBtn}></Box>}
                </Box>
                <PrimaryIcon
                  width="20px"
                  height="20px"
                  icon={
                    toDateOpen
                      ? KeyboardArrowUpOutlinedIcon
                      : KeyboardArrowDownOutlinedIcon
                  }
                />
              </Box>
            </li>
            <Collapse in={toDateOpen}>
              <ul className={classes.rsWaringFilterlistview}>
                <li>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      // className={classes.removeBorderColor}
                      open={openToDate}
                      onClose={() => setOpenToDate(false)}
                      disableFuture
                      // label="To date"
                      inputFormat="DD-MM-YYYY"
                      value={filterToDate}
                      onChange={(newDate) => {
                        handleDateFilterAction(newDate, "to_date");
                      }}
                      renderInput={(params) => (
                        <TextField
                          fullWidth
                          InputLabelProps={{
                            shrink: true,
                          }}
                          size="small"
                          name="order_date"
                          {...params}
                          error={filterToDateError !== ""}
                          helperText={filterToDateError}
                          InputProps={{
                            endAdornment: (
                              <>
                                {filterToDate !== null && (
                                  <InputAdornment
                                    position="end"
                                    onClick={() =>
                                      handleDateFilterAction(null, "to_date")
                                    }
                                    className="cursor-pointer"
                                  >
                                    <PrimaryIcon
                                      width="20px"
                                      icon={ClearIcon}
                                    />
                                  </InputAdornment>
                                )}
                                <InputAdornment
                                  position="end"
                                  onClick={() => setOpenToDate(true)}
                                  className="cursor-pointer"
                                >
                                  <PrimaryIcon
                                    width="20px"
                                    icon={InsertInvitationIcon}
                                  />
                                </InputAdornment>
                              </>
                            ),
                          }}
                        />
                      )}
                    />
                  </LocalizationProvider>
                </li>
              </ul>
            </Collapse>
            <hr />
            <li className={classes.rsCursor} onClick={() => handleStaffopen()}>
              <Box className={classes.rsListAlignment}>
                <Box>
                  Staff
                  {Object.keys(selectedStaffData).length !== 0 && (
                    <Box className={classes.rsActiveBtn}></Box>
                  )}
                </Box>
                <PrimaryIcon
                  width="20px"
                  height="20px"
                  icon={
                    staffOpen
                      ? KeyboardArrowUpOutlinedIcon
                      : KeyboardArrowDownOutlinedIcon
                  }
                />
              </Box>
            </li>
            <Collapse in={staffOpen}>
              <ul className={classes.rsWaringFilterlistview}>
                <li>
                  <StaffAutoComplete
                    fullWidth
                    multiple
                    maxValue={1}
                    surgeryListFlag={staffListFlag}
                    // className={classes.autoCompleteBox}
                    value={selectedStaffData}
                    handleChange={(value) => handleStaffFilterAction(value)}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder="Staff"
                        // label="Staff"
                      />
                    )}
                  />
                </li>
              </ul>
            </Collapse>
            <hr />
          </Menu>
        </Box>
      </Grid>
      <ActivityLogTable
        columnSortingOrder={columnSortingOrder}
        defaultColumnOrderBy={defaultColumnOrderBy}
        setColumnSortingOrder={setColumnSortingOrder}
        activityList={activityList}
        setTarget={setTarget}
      />
    </Grid>
  );
};
const mapStateToProps = (state) => ({
  activityList: state.activity.activityList,
});

const mapDispatchToProps = (dispatch) => ({
  getActivityAction: (payload, loadmore) =>
    dispatch({ type: START_GET_ACTIVITY_LOG, payload, loadmore }),
  getSearchStaffListAction: (payload) =>
    dispatch({ type: START_GET_FIELD_STAFF_LIST, payload }),
  reSetActivityState: () => dispatch({ type: RESET_ACTIVITY_STATE }),
});
export default connect(mapStateToProps, mapDispatchToProps)(ActivityLogMain);
